import { Component, OnInit } from "@angular/core";
import {
  MatTableDataSource,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";

interface EventBetSummary {
  eventId: string;
  marketId: string;
  eventName: string;
  openDate: number; // unixmilli
  bfMarketName: string;
  totalBetsCount: number;
  bfGGR: number;
  srGGR: number;
}

@Component({
  selector: "app-event-arbitrage-report",
  templateUrl: "./event-arbitrage-report.component.html",
  styleUrls: ["./event-arbitrage-report.component.scss"],
})
export class EventArbitrageReportComponent implements OnInit {
  selected: any = { startDate: null, endDate: null };
  summaryList = new MatTableDataSource<EventBetSummary>([]);
  displayedColumns: string[] = [
    "openDate",
    "eventName",
    "bfMarketName",
    "totalBetsCount",
    "srGGR",
    "bfGGR",
    "totalGGR",
  ];
  loading: boolean = false;
  sportId: string = "";
  sportName: string = "";

  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.sportId = params.sportId || "";
      this.sportName = params.sportName || "";

      if (params.startTime && params.endTime) {
        this.selected = {
          startDate: params.startTime !== "0" ? new Date(params.startTime * 1000) : null,
          endDate: params.endTime !== "0" ? new Date(params.endTime * 1000) : null,
        };
      } else {
        // Default to yesterday
        this.selected = {
          startDate: moment().subtract(1, "days").startOf("day").toDate(),
          endDate: moment().subtract(1, "days").endOf("day").toDate(),
        };
      }

      if (this.sportId && this.selected.startDate && this.selected.endDate) {
        this.getEventSummary();
      }
    });
  }

  getEventSummary = () => {
    if (!this.selected.startDate || !this.selected.endDate || !this.sportId) {
      this.appService.openErrorBar("Missing required parameters");
      return;
    }

    this.loading = true;
    const filters = {
      sportId: this.sportId,
      startTime: Math.floor(new Date(this.selected.startDate).getTime() / 1000),
      endTime: Math.floor(new Date(this.selected.endDate).getTime() / 1000),
    };

    this.appService.getEventBetsSummary(filters).subscribe(
      (res) => {
        this.loading = false;
        if (res.status === "RS_OK") {
          const data = res.summary || res.data || [];
          this.summaryList = new MatTableDataSource<EventBetSummary>(data);
        } else if (res.errorDescription === "Invalid Token!") {
          this.appService.openErrorBar(res.errorDescription);
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        } else {
          this.appService.openErrorBar(
            res.errorDescription || "Failed to fetch event report"
          );
        }
      },
      (error) => {
        this.loading = false;
        const errorMessage = (error.error && error.error.errorDescription)
          ? error.error.errorDescription
          : "Error fetching event report";
        this.appService.openErrorBar(errorMessage);
      }
    );
  };

  calculateTotalGGR(bfGGR: number, srGGR: number): number {
    return (bfGGR || 0) + (srGGR || 0);
  }

  formatGGR(value: number): string {
    if (value === null || value === undefined) {
      return "0";
    }
    return value.toFixed(0);
  }

  getGGRClass(value: number): string {
    if (value > 0) {
      return "ggr-positive";
    } else if (value < 0) {
      return "ggr-negative";
    }
    return "";
  }

  formatOpenDate(openDate: number): string {
    if (!openDate) return "";
    // openDate is in unixmilli, convert to moment and format
    return moment(openDate).format("DD-MM-YYYY HH:mm");
  }

  goBack() {
    this.router.navigate(["/reports/arbitrage-report"], {
      queryParams: {
        startTime: this.selected.startDate
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
        endTime: this.selected.endDate
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
      },
    });
  }

  navigateToPlacedBets(element: EventBetSummary) {
    if (!element || !element.eventId || !element.marketId) {
      return;
    }

    const queryParams = {
      eventId: element.eventId,
      marketId: element.marketId || "",
      eventName: element.eventName || element.eventId,
      bfMarketName: element.bfMarketName || "",
      sportId: this.sportId,
      sportName: this.sportName,
      startTime: this.selected.startDate
        ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
        : 0,
      endTime: this.selected.endDate
        ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
        : 0,
      totalBetsCount: element.totalBetsCount || 0,
      bfGGR: element.bfGGR || 0,
      srGGR: element.srGGR || 0,
    };

    this.router.navigate(["/reports/placed-bets"], {
      queryParams: queryParams,
    });
  }
}

